import React from "react";
import FullScreenModal from "@/features/shell/components/FullScreenModal/FullScreenModal";
import { Search } from "@/features/search/components/Search";
import { useShellStore } from "@/features/shell/stores/shellStore";
import { Clamp } from "@picklebet/ui";
import { Caret } from "@picklebet/ui";

import * as styles from "./FullScreenSearchDialog.module.scss";

const CloseButton = () => {
  const setModal = useShellStore((state) => state.setModal);

  return (
    <Clamp onClick={() => setModal(null)} className={styles.closeButton}>
      <Caret variant={"left"} />
    </Clamp>
  );
};

const FullScreenSearchDialog = () => {
  const modal = useShellStore((state) => state.modal);
  const setModal = useShellStore((state) => state.setModal);
  const isOpen = modal === "search";

  return (
    <FullScreenModal
      className={styles.searchModal}
      contentClassName={styles.dialog}
      hideHeader
      isOpen={isOpen}
      onClose={() => setModal(null)}
    >
      <Search className={styles.searchInputOffset} />
      <CloseButton />
    </FullScreenModal>
  );
};

export { FullScreenSearchDialog };
